import getValue from 'lodash/get';
import { renderSiteWidget } from 'react-app';
import { ContactSiteViewModel } from 'clinicaltrial_view/prescreener';
import { GOOGLE_MAPS_API_KEY } from "commons/config/constants";
import $ from 'jquery';
(function ($, document, window) {
  const widgetId = window.__WIDGET_ID__;
  const hasPrescreener = window.__HAS_PRESCREENER__;
  const googlePlaceApiKey = GOOGLE_MAPS_API_KEY;
  const $contactSiteForm = document.getElementById('contact-site-form');
  const $alreadyContactedSite = $('#already-contacted-site');
  const referralFormLocale = JSON.parse(
    document.getElementById('referral-form-locale').textContent,
  );

  let contactSiteViewModel = null;

  function onSiteContacted({
    trialId,
    site,
    existingVolunteer,
    volunteerLink,
  }) {
    const $alreadyContactedSiteName = $alreadyContactedSite.find(
      '#already-contacted-site-name',
    );
    const $alreadyContactedSiteAddress = $alreadyContactedSite.find(
      '#already-contacted-site-address',
    );
    const $alreadyContactedSiteTimestamp = $alreadyContactedSite.find(
      '#already-contacted-site-timestamp',
    );

    $alreadyContactedSiteName.text(site.name);
    $alreadyContactedSiteAddress.text(site.address);
    $alreadyContactedSiteLabel.text(
      getValue(referralFormLocale, 'siteContactSuccessMessage'),
    );

    $alreadyContactedSiteTimestamp.addClass('d-none');
    $alreadyContactedSite.removeClass('d-none');
  }

  function onResetSiteContacted() {
    $alreadyContactedSite.addClass('d-none');
  }

  $(function () {
    if (!hasPrescreener) {
      contactSiteViewModel = new ContactSiteViewModel({
        tabId: 'send-message-tab',
        canSendWithAnnotations: false,
        onSiteContacted,
        widgetId,
        onResetSiteContacted,
        referralFormLocale,
      });
    }

    try {
      !hasPrescreener &&
        renderSiteWidget('site-widget', {
          onSiteConnectClick: contactSiteViewModel.handleSiteConnect,
          onTrialSitesChange: contactSiteViewModel.handleTrialSitesChange,
          useBrowserLocation: false,
          canViewByCountry: false,
          google_place_api_key : googlePlaceApiKey
        });
    } catch (error) {
      console.log(error);
    }

    !hasPrescreener && ko.applyBindings(contactSiteViewModel, $contactSiteForm);
  });
})($.noConflict(), document, window);
